import axios from "axios";
import { useRuntimeConfig } from "#app";
export const useApi = () => {
  const config = useRuntimeConfig();
  const api = axios.create({
    baseURL: config?.public?.baseUrl?.toString() || "/"
  });
  return api;
};
